/* eslint-disable import/no-anonymous-default-export */
import type { Theme } from '@mui/material';
import {
    Checkbox,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    useMediaQuery,
} from '@mui/material';
import {
    RecordContextProvider,
    SimpleListLoading,
    useListContext,
    ReferenceField,
    TextField
} from 'react-admin';
import { Link } from 'react-router-dom';
import { User } from '@/types';

export const UserListContent = () => {
    const {
        data: users,
        error,
        isPending,
        onToggleItem,
        selectedIds,
    } = useListContext<User>();
    const isSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('md')
    );
    if (isPending) {
        return <SimpleListLoading hasLeftAvatarOrIcon hasSecondaryText />;
    }
    if (error) {
        return null;
    }
    const now = Date.now();

    return (
        <>
            <List dense>
                {users.map(item => (
                    <RecordContextProvider key={item.id} value={item}>
                        <ListItem disablePadding>
                            <ListItemButton
                                component={Link}
                                to={`/users/${item.id}/show`}
                            >
                                <ListItemIcon sx={{ minWidth: '2.5em' }}>
                                    <Checkbox
                                        edge="start"
                                        checked={selectedIds.includes(
                                            item.id
                                        )}
                                        tabIndex={-1}
                                        disableRipple
                                        onClick={e => {
                                            e.stopPropagation();
                                            onToggleItem(item.id);
                                        }}
                                    />
                                </ListItemIcon>
                                <ListItemText
                                    primary={`${item.name}`}
                                    secondary={
                                        <>
                                            {item.role_id != null && (
                                                <ReferenceField
                                                    source="role_id"
                                                    reference="roles"
                                                    link={false}
                                                >
                                                    <TextField source="name" />
                                                </ReferenceField>
                                            )}
                                            
                                        </>
                                    }
                                />
                                <ListItemText
                                    primary={`${item.email}`}
                                />
                                <ListItemText
                                    primary="Is Active?"
                                    secondary={
                                        <>
                                            {item.is_active ? 'Yes' : 'No'}
                                        </>
                                    }
                                />
                                <ListItemText
                                    primary="Is Superuser?"
                                    secondary={
                                        <>
                                            {item.is_superuser ? 'Yes' : 'No'}
                                        </>
                                    }
                                />
                                <ListItemText
                                    primary="Can Sign?"
                                    secondary={
                                        <>
                                            {item.can_sign ? 'Yes' : 'No'}
                                        </>
                                    }
                                />
                            </ListItemButton>
                        </ListItem>
                    </RecordContextProvider>
                ))}

                {users.length === 0 && (
                    <ListItem>
                        <ListItemText primary="No users found" />
                    </ListItem>
                )}
            </List>
        </>
    );
};
